import template from './template.html';
import blockBase from "../../mixins/blockBase";

export default {
    name: 'info',
    template: template,
    mixins: [
        blockBase,
    ]
};